import { LETTER_SETS } from '@/types';

export const getLetterSetBySound = (sound: string): string[] | undefined =>
  LETTER_SETS.find((letterSet) => letterSet.includes(sound));

export const getLetterSetsBySounds = (
  sounds: Array<string>,
): Array<Array<string>> =>
  LETTER_SETS.filter((letterSet) =>
    sounds.some((sound) => letterSet.includes(sound)),
  );
